const formatAddressToDisplay = (address) => {
	if (!address?.length) return "";
	const splitted = address.split(",");
	const last = splitted[splitted.length - 1].trim();
	splitted[splitted.length - 1] = `\n${last}`;
	return splitted.join();
};

export default formatAddressToDisplay;
